import React from 'react';

const ModalFallback = () => (
  <div className="c-lazy-modal-fallback LazyModal LazyModal_1" />
);

export default ModalFallback;
